(function () {
  function initCard(card) {
    var dataEl = card.querySelector('.quick-add-variant-data');
    if (!dataEl || card.dataset.quickAddInit === 'true') return;
    card.dataset.quickAddInit = 'true';

    var variantMap = JSON.parse(dataEl.textContent);

    var hasColor = card.dataset.colorIndex !== '-1';
    var hasSize = card.dataset.sizeIndex !== '-1';

    var colorBtns = card.querySelectorAll('.quick-add-color-swatch');
    var sizeBtns = card.querySelectorAll('.quick-add-size-btn');
    var addBtn = card.querySelector('.quick-add-to-cart-btn');
    var label = addBtn.querySelector('.btn-label');

    // If a dimension doesn't exist on this product, treat it as
    // "already selected" (empty string) so the other dimension alone
    // can unlock Add To Cart.
    var selectedColor = hasColor ? null : '';
    var selectedSize = hasSize ? null : '';

    function refreshSizes() {
      if (!hasSize) return;
      sizeBtns.forEach(function (btn) {
        var key = (selectedColor || '') + '|' + btn.dataset.sizeValue;
        var v = variantMap[key];
        var ok = !!(v && v.available);
        btn.disabled = !ok;
        btn.classList.toggle('unavailable', !ok);
      });
    }

    function refreshAddButton() {
      if (selectedColor === null || selectedSize === null) {
        addBtn.disabled = true;
        return;
      }
      var key = selectedColor + '|' + selectedSize;
      var v = variantMap[key];
      var ok = !!(v && v.available);
      addBtn.disabled = !ok;
      addBtn.dataset.variantId = ok ? v.id : '';
    }

    colorBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        colorBtns.forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
        selectedColor = btn.dataset.colorValue;
        selectedSize = hasSize ? null : '';
        sizeBtns.forEach(function (b) { b.classList.remove('selected'); });
        refreshSizes();
        refreshAddButton();
      });
    });

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        sizeBtns.forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
        selectedSize = btn.dataset.sizeValue;
        refreshAddButton();
      });
    });

    addBtn.addEventListener('click', function () {
      var variantId = addBtn.dataset.variantId;
      if (!variantId) return;

      addBtn.disabled = true;
      label.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add_failed');
          return res.json();
        })
        .then(function () {
          label.textContent = 'Added \u2713';
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

          // Try to pop the theme's cart drawer open, if it exists.
          var drawer = document.querySelector('cart-drawer, #cart-drawer');
          if (drawer) {
            if (typeof drawer.show === 'function') drawer.show();
            else if (typeof drawer.open === 'function') drawer.open();
            else drawer.setAttribute('open', '');
          }

          setTimeout(function () {
            label.textContent = 'Add To Cart';
            refreshAddButton();
          }, 1500);
        })
        .catch(function () {
          label.textContent = 'Try again';
          setTimeout(function () {
            label.textContent = 'Add To Cart';
            refreshAddButton();
          }, 1500);
        });
    });

    refreshSizes();
    refreshAddButton();
  }

  function init() {
    document.querySelectorAll('.quick-add-card').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run after the collection grid re-renders (filters, sort,
  // pagination via AJAX). Dispatch this event yourself if your theme
  // doesn't already fire something equivalent.
  document.addEventListener('collection:reload', init);
})();